import SalesforceAPI from "./salesforce"

export default (jwt) => new SalesforceAPI(jwt)
